import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import WarningIcon from '@mui/icons-material/Warning';

import {
  Avatar,
  Box,
  Divider,
  Grid
} from '@mui/material';

import {
  Dt,
  StyledButton,
  Typography
} from '../../components/interface';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';
import { AlertEmailSent } from '../../components/alerts/EmailSent';

import { Company } from '../../models/Company';

import { getCookie, setCookie } from 'react-use-cookie';

type Props = {};

export const DashboardAdmin: FunctionComponent<Props> = () => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [emailSent, setEmailsent] = useState<boolean>(false);
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('panelmetrics_active_company_id') || '');


  const {
    data: company,
    // isLoading: bookYearsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: companyRefetch,
  } = useQuery({
    queryKey: ["company", 'memoq_stats'],
    queryFn: () =>
      fetchOne<Company>(
        "/nl/v3/objects/fetch_all",
        {
          object: "company",
          fields: [
            "id", 'name', 'get_item', 'memoq_stats', 'extra_data'
          ],
          id: activeCompany
        },
        login
      ),
    enabled: !!login && !!activeCompany
  });








  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<any>(
        "/nl/v3/objects/custom_action",
        pars.formData,
        login
      );
    },
    onSuccess: (data, variables, context) => {
      setEmailsent(true);
    },
  });








  return <>
    <Grid container spacing="8">
      {!company && <Grid item xs={12}>Select a company in the sidebar to see more actions.</Grid>}
      {!!company && <Grid item xs={12}>
        <Typography variant="h2">{company?.name}</Typography>
      </Grid>}

      <Grid item xs={6}>
        <Typography variant="h4">Personeel</Typography>
        <Divider sx={{marginBottom: 2}} />
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h4">Ouders</Typography>
        <Divider sx={{marginBottom: 2}} />
      </Grid>

      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last year)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.internal_mails_yr.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 1, marginTop: 1}} />
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last year)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.external_mails_yr.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 1, marginTop: 1}} />
      </Grid>

      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last 6 months)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.internal_mails_6m.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 1, marginTop: 1}} />
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last 6 months)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.external_mails_6m.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 1, marginTop: 1}} />
      </Grid>

      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last month)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.internal_mails_1m.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 2, marginTop: 2}} />
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h5"># Mails (last month)</Typography>
        <Typography variant="body1">{company?.memoq_stats?.external_mails_1m.toLocaleString()}</Typography>
        <Divider sx={{marginBottom: 2, marginTop: 2}} />
      </Grid>

      {!!company?.extra_data?.memoq_int && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <StyledButton
          label="Send comment export"
          id="send_comment_export"
          loading={mutationCustomAction.isPending}
          contained
          sx={{
            marginTop: 1,
            marginLeft: 1,
            marginRight: 1
          }}
          onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'report_version',
                class_action: 'custom_api_send_memoq_comments',
                project_id: company?.extra_data?.memoq_int,
                location: 0
              }
            });
          }}
        />
      </Grid>}




      {/* <Grid item xs={6}>
        <Typography variant="subtitle1" sx={{textDecoration: 'underline', marginBottom: 3}}>Last 10 organiser logs</Typography>

        <Box sx={{
          border: '1px solid #233959',
          backgroundColor: '#cedbed',
          padding: 1,
          borderRadius: 1
        }}>
          <Grid container spacing="8">
            {(orgLogs || []).length < 1 && <Grid item xs={12}>
              <Typography sx={{fontSize: '0.8rem', fontStyle: 'italic'}}>No results found...</Typography>
            </Grid>}
            {(orgLogs || []).length > 0 && (orgLogs || []).map((log, i) => <>
              {i > 0 && <Grid item xs={12}><Divider /></Grid>}
              <Grid item xs={5}>
                <Avatar src={log.company?.get_item} sx={{width: 60, height: 60, display: 'inline-block', float: 'left', marginRight: 2}}>{log.company?.name}</Avatar>

                <Typography sx={{fontSize: '0.9rem', display: 'inline-block', height: '20px', width: 'calc(100% - 80px)', lineHeight: '20px', fontWeight: 'bold'}}>
                  {log.user?.first_name}
                </Typography>
                <Typography sx={{fontSize: '0.9rem', display: 'inline-block', height: '20px', width: 'calc(100% - 80px)', lineHeight: '20px', fontStyle: 'italic'}}>
                  {log.company?.name}
                </Typography>
                <Typography sx={{fontSize: '0.9rem', display: 'inline-block', height: '20px', width: 'calc(100% - 80px)', lineHeight: '20px'}}>
                  <Dt d={log.created_at} f="dd/LL/yy t" />
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography sx={{fontSize: '0.9rem', lineHeight: '60px'}}>{log.action_key}</Typography>
              </Grid>
            </>)}
          </Grid>
        </Box>
      </Grid> */}

    </Grid>
    {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      {!!emailSent && <AlertEmailSent open={emailSent} setOpen={setEmailsent} />}
  </>;
}
